import { toDatedRouteSlots } from 'utils/routeStopOperations/v2/slotPayloads'
import { makeAssignDailySlotStep } from 'utils/routeStopOperations/v2/steps/assignDailySlot'
import { makeChangeDateRouteSlotStep } from 'utils/routeStopOperations/v2/steps/changeDateRouteSlot'
import { makePreflightStep } from 'utils/routeStopOperations/v2/steps/preflight'
import { makeSequenceDailySlotStep } from 'utils/routeStopOperations/v2/steps/sequenceDailySlot'
import { makeVerifyStep } from 'utils/routeStopOperations/v2/steps/verify'

import type { ChangeDateIntent, Deps, OperationPlan, PipelineStep } from 'types/modules/routing'

// Daily-only by construction: `includeMaster` never reaches here, the strategy sends it to v1-bulk.
const STRATEGY_ID = 'v3-slot' as const

export const buildChangeDateSlotPipeline = (intent: ChangeDateIntent, deps: Deps): OperationPlan => {
  const steps: PipelineStep[] = [makePreflightStep({ intent }, deps) as PipelineStep]

  steps.push(
    makeChangeDateRouteSlotStep(
      {
        routeId: intent.routeId,
        toServiceDate: intent.toServiceDate,
        slots: toDatedRouteSlots(intent.stops, intent.fromServiceDate),
      },
      deps
    ) as PipelineStep
  )

  // `changeDateBySlot` takes no route and drops the routing the old date held, so the move needs
  // placing. After the flip, never before: `ValidateNewStopsDaily` rejects an assign on an unreached date.
  steps.push(
    makeAssignDailySlotStep({ routeId: intent.routeId, serviceDate: intent.toServiceDate, rows: intent.stops }, deps) as PipelineStep
  )

  if (intent.allOrderedStops && intent.allOrderedStops.length > 0) {
    steps.push(
      makeSequenceDailySlotStep(
        { routeId: intent.routeId, serviceDate: intent.toServiceDate, orderedRows: intent.allOrderedStops },
        deps
      ) as PipelineStep
    )
  }

  steps.push(makeVerifyStep({ intent }, deps) as PipelineStep)

  return { strategy: STRATEGY_ID, intent, steps }
}
